import { reportMainNavigationSelectors as selector } from "../Selectors/index";

export const reportMainNavigationReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET_REPORT_MAIN_ROLE_SUCCESS:
      // console.log("Setting Report Main Navigation in Redux state:", payload);
      return payload;

    default:
      return state;
  }
};